import { render } from "./apiAccess.vue?vue&type=template&id=764bb616"
import script from "./apiAccess.vue?vue&type=script&lang=js"
export * from "./apiAccess.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__